var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7734 17.5236L13.6484 11.3986C13.0912 10.8414 13.0912 9.93801 13.6484 9.38081C14.2056 8.82362 15.1089 8.82362 15.6661 9.38081L22.8 16.5147C23.3572 17.0719 23.3572 17.9753 22.8 18.5325L15.6661 25.6664C15.1089 26.2236 14.2056 26.2236 13.6484 25.6664C13.0912 25.1092 13.0912 24.2058 13.6484 23.6486L19.7734 17.5236Z",
    fill: "#92929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevRight);
export default __webpack_public_path__ + "static/media/ChevRight.36e64c6e50d663b857024374609a11d0.svg";
export { ForwardRef as ReactComponent };